import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Typography,
  Avatar,
} from "@mui/material";
import { TEXT_CONSTANTS } from "../../../utils/text-constants/textConstants";
import SmsIcon from "@mui/icons-material/Sms";
import Button from "../button/Button";
import { useDispatch } from "react-redux";
import { sendSMS } from "../../../screens/patient-screen/patientSaga";

const SendSMSDialog = ({ open, onClose, contact }: any) => {
  const dispatch = useDispatch();
  const phone =
    contact?.find(
      (c: any) =>
        c.label.toLowerCase().includes("leader contact") ||
        c.label.toLowerCase().includes("contact number") || 
        c.label.toLowerCase().includes("patient contact")
    )?.value || "";
  const name =
    contact?.find((c: any) => c.label.toLowerCase().includes("name"))?.value ||
    "";

  const [message, setMessage] = useState("");
  const isDisabled = message.trim().length === 0;

  const handleSend = () => {
    // Implement your send SMS logic here
    const data = {
      apiPayload: {
        // Send the number as plain digits (strip hyphens/spaces/parentheses;
        // keep an optional leading "+").
        number: phone?.replace(/[^\d+]/g, "") || "",
        message: message,
      },
      onClose,
    };
    dispatch(sendSMS(data));
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        style: {
          //   height: "80vh", // Set dialog height to 80% of viewport height
          //   maxHeight: "600px", // Maximum height limit
          overflowX: "hidden",
        },
      }}
    >
      <DialogTitle>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <Avatar sx={{ bgcolor: "#43a047" }}>
            <SmsIcon />
          </Avatar>
          <span>Send SMS</span>
        </div>
      </DialogTitle>
      <DialogContent>
        <Typography variant="subtitle2" gutterBottom>
          To: <b>{name}</b> ({phone})
        </Typography>
        <TextField
          label="Message"
          fullWidth
          margin="normal"
          multiline
          minRows={4}
          value={message}
          onChange={(e) => setMessage(e.target.value)}
        />
      </DialogContent>
      <DialogActions style={{ padding: "16px 24px" }}>
        <Button
          label={TEXT_CONSTANTS?.CANCEL}
          variant="outlined"
          onClickCb={onClose}
          style={{
            width: "120px",
            height: "44px",
            padding: "12px 20px",
            fontSize: "16px",
            backgroundColor: "white",
            border: "none",
            color: "#393939",
          }}
        />
        <Button
          type="submit"
          label={"Send"}
          variant="contained"
          onClickCb={handleSend}
          disabled={isDisabled}
          style={{
            padding: "8px 35px",
            fontSize: "16px",
          }}
        />
      </DialogActions>
    </Dialog>
  );
};

export default SendSMSDialog;
